import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK,
} from '../../../../actions/actionTypes';

const contentLinkSave = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK
);

export default contentLinkSave;
